module.exports = __webpack_public_path__ + "static/media/nps-info.0d2e8dce.svg";